<syslink-title text="{{ 'Stock Move Supplier Outgoings' }}"></syslink-title>
<app-stock-move-outgoing-grid
  #grid
  [permissionKey]="'list'"
  [canUpdate]="false"
  (add)="onAddButtonClicked()"
  [contextMenuItems]="contextMenuItems"
  [expand]="expand"
  detailsUrl="/stockmoves/supplieroutgoings"
  storageKey="stock-move-supplieroutgoings"
  [filter]="filter"
>
</app-stock-move-outgoing-grid>
<app-document-create-modal
  #createModal
  title="Create supplier outgoing"
  [thirdFilter]="supplierFilter"
  detailsUrl="/thirds/suppliers/"
  (validate)="onCreateValidated($event)"
  [showSubject]="false"
></app-document-create-modal>
<syslink-confirm-modal
  #confirmModal
  (onValidate)="onConfirmModalValidated($event)"
></syslink-confirm-modal>
<app-stock-move-outgoing-status-select-modal
  #statusModal
  (validate)="onConfirmModalValidated($event)"
></app-stock-move-outgoing-status-select-modal>
